/**
 * Where a participant's gateway connects for the ISO 8583 card link.
 *
 * Only the deployment knows it: in production a TLS edge answers on its own
 * hostname and port, which the card engine publishes in /healthz as `link`.
 * The portal's build may name a host instead (VITE_ISO8583_HOST). Nothing else
 * is used: the browser's own host is not the card link's, so when neither says,
 * the endpoint is unpublished and the pages show placeholders and who to ask,
 * rather than an address the participant cannot use.
 */

export const CARD_HOST_PLACEHOLDER = '<card host>';
export const CARD_PORT_PLACEHOLDER = '<card port>';

const ON_THIS_MACHINE = /^(localhost|127\.0\.0\.1|::1|\[::1\])$|\.localhost$/i;

/**
 * @param {object|null} health        the card engine's /healthz answer
 * @param {string}      [configuredHost] the host the portal was built with
 * @returns {{host: string, port: number|string, tls: boolean, published: boolean, local: boolean}}
 *   `local` marks a development deployment on the same machine as the browser.
 */
export function cardEndpoint(health, configuredHost) {
  const link = health?.link || {};
  const host = String(link.host || configuredHost || '').trim();
  if (!host) {
    return { host: CARD_HOST_PLACEHOLDER, port: CARD_PORT_PLACEHOLDER, tls: false, published: false, local: false };
  }
  return {
    host,
    port: link.port || health?.iso8583Port || CARD_PORT_PLACEHOLDER,
    tls: link.tls === true,
    published: true,
    local: ON_THIS_MACHINE.test(host),
  };
}
